import React from 'react';
import App from '../App';
import './index.css';

export default ({ history, location }) => <App history={history} location={location} />;
